import { useEffect, useState } from 'react';

import './book-now.styles.css'
import ImageSlider from '../../components/image-slider/ImageSlider';
import BookingForm from './form/BookingForm';
import Banner from '../../components/banner/Banner';

const importAllImages = (r: any): string[] => r.keys().map(r);

declare const require: any;
const BookNow = () => {

    const [images, setImages] = useState<string[]>([]);

    useEffect(() => {
        const imagesArray = importAllImages(
            require.context('../../assets/work', false, /\.(png|jpe?g|gif)$/)
        );
        setImages(imagesArray);
    }, []);

    return (
        <>
            <Banner />
            <BookingForm />
            <div className='slider-title'>
                <h1>
                    Our Work
                </h1>
            </div>
            <ImageSlider images={images} autoSlideInterval={5000} />
        </>
    );
}

export default BookNow;
